<template>
  <div></div>
</template>

<script>
  export default {
    methods: {
      formSubmit (payloads) {
        this.loader = this.$loading.show(this.$_loaderOptions)
        payloads['marketId'] = this.market.marketId
        if (this.instagramMediaId) {
          payloads['instagramMediaId'] = this.instagramMediaId
        }
        this.marketFeedback({
          data: payloads
        })
          .then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide('feedback-form')
            })
            this.$notify({
              group: 'app',
              type: 'success',
              title: this.$t('notifications.title.success'),
              text: this.$t('notifications.text.feedback.success_feedback_sent')
            })
          })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
          .finally(() => {
            this.loader.hide()
          })
      }
    }
  }
</script>

<style scoped>

</style>
